<div class="filters">
  <mat-form-field
    appearance="outline"
    class="date-wrapper"
  >
    <mat-label>Период</mat-label>
    <mat-date-range-input
      [formGroup]="rangeForm"
      [rangePicker]="picker"
    >
      <input
        #dateRangeStart
        matInput
        matStartDate
        appDateInput
        placeholder="Начальная"
        formControlName="dateFrom">

      <input
        #dateRangeEnd
        matInput
        matEndDate
        appDateInput
        placeholder="Конечная"
        formControlName="dateTo"
        (dateChange)="handleDateRangeChange()"
      >
    </mat-date-range-input>
    <div class="toggle">
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-datepicker-toggle
        matSuffix
        (click)="clearDateRange()"
      >
        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
      </mat-datepicker-toggle>
    </div>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Быстрый выбор даты</mat-label>
    <mat-select
      [formControl]="fastPeriodControl"
      (selectionChange)="handleSelectChange($event.value)"
    >
      <mat-option></mat-option>
      @for (option of periodSelectData; track option.id) {
        <mat-option [value]="option.id">
          {{ option.value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="zoom-options-container"
  >
    <mat-label>Зум</mat-label>
    <mat-select
      [(value)]="currentZoomOption"
      (valueChange)="handleZoomSelectValueChange()"
    >
      @for (zoomOption of ZOOM_OPTIONS; track zoomOption) {
        <mat-option
          [value]="zoomOption"
        >
          {{ zoomOption }}%
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
